import React from "react";

import { MenuButton as ReachMenuButton } from "@reach/menu-button";

import Button, { ButtonProps } from "../Button";
import { ChevronDownIcon } from "../../../icons";

type MenuButtonProps = {
  as?: keyof JSX.IntrinsicElements | React.ComponentType;
  noIndicator?: boolean;
} & Omit<ButtonProps, "trailingIcon" | "leadingIcon"> &
  Record<string, unknown>;

const MenuButton: React.FC<MenuButtonProps> = ({
  children,
  as = Button,
  variant = "ghost",
  noIndicator = false,
  ...props
}) => {
  return (
    <ReachMenuButton
      as={as}
      {...(as === Button ? { trailingIcon: noIndicator ? undefined: ChevronDownIcon, variant } : {})}
      {...props}
    >
      {children}
    </ReachMenuButton>
  );
};

export default React.memo(MenuButton);
